import React from 'react';

import useTranslation from 'hooks/use-translation';
import { BaseModal } from '../base-modal';
import { DutchiePayHeader, DutchiePayTextBody } from '../../components';
import { DutchiePayLeaveButton } from './leave-now-button';

type LearnMoreModalProps = {
  onCloseModal: () => void;
};

export function DutchiePayCancelModal({ onCloseModal }: LearnMoreModalProps): JSX.Element {
  const { t, Trans } = useTranslation();

  return (
    <BaseModal onCloseModal={onCloseModal}>
      <DutchiePayHeader>{t('dutchiePay.leaveSignUp', 'Leave sign up?')}</DutchiePayHeader>
      <DutchiePayTextBody>
        <Trans i18nKey='dutchiePay.returnedToCart'>
          You will be returned to your cart and you can use other payment options.
        </Trans>
      </DutchiePayTextBody>

      <DutchiePayLeaveButton onCloseModal={onCloseModal} />
    </BaseModal>
  );
}
